import React from 'react'

import "./HomeSection1.css"

import homeImg2 from "../../../../assets/imgs/homeImg2.png"

function HomeSection1() {
  return (
    <div className='hs1'>
        <span className='hs1-head'>INCIDENTS</span>
        <span className='hs1-title'>Why we Started Sync Verse</span>
        <div className='hs1-inner'>
            <div className='hs1-left'>
                <p>According to the National Crime Records Bureau (NCRB), an average of 35 people died every day in India due to fire accidents between2016 and 2020.</p>
                <br />
                <ul>
                    <li>Average 12,750 deaths in fire accidents in India every year during 2016-2020.</li>
                </ul>
                <ul>
                    <li>16,695 fire accidents and 16,900 deaths reported in India in 2016.</li>
                </ul>
                <ul>
                    <li>3603 fire accidents(LPG) and 3628 deaths reported in India in 2017.</li>
                </ul>

            </div>
            <div className='hs1-right'>
                <img src={homeImg2} alt="" />

            </div>

        </div>
      
    </div>
  )
}

export default HomeSection1
